<template lang="">
    <div class="app-project-sources-golden-source-navbar">
        <h2 class="app-project-sources-golden-source-navbar__title">Table of Contents</h2>
        <div class="element-progress">
            <p class="element-progress__text">{{ projectReviewCompletion }}% of topics reviewed </p>
            <div class="element-progress__bar">
                <div class="element-progress__bar-filled" ref="progressBarFill"></div>
            </div>
        </div>
        <form @submit.prevent="search"
            class="app-search">
            <div class="input text">
                <input
                    type="search"
                    placeholder="Search for terms or phrases"
                    v-model="input"
                    :disabled="searchQuery.length > 0"
                    @search="onSearch"
                    required>
            </div>
        </form>
        <div v-if="searchQuery" class="element-chip is--info">
            {{ searchQuery }}
            <svg class="element-icon--x element-icon" width="1em" height="1em" @click="deleteTag()"><use href="/img/icons.svg#icon-x"></use></svg>
        </div>
        <div class="app-project-sources-golden-source-navbar__domains app-vertical-navigation">
            <div v-for="parent in parents" :key="parent.uuid" class="app-project-sources-golden-source-navbar__domain">
                <div @click="toggleExpanded(parent)" :class="['app-vertical-navigation__menu-item', {'is--selected': parent.expanded}]">
                    <span class="app-vertical-navigation__menu-item-title" v-html="highlightMatch(parent.name)"></span>
                    <svg class="element-icon--chevron-down element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-down"></use></svg>
                </div>
                <ul v-if="parent.expanded">
                  <li v-for="child in parent.topics" :key="child.uuid" :class="['app-vertical-navigation__submenu-item', { 'is--active': child.isActive}]">
                    <a :href="location + child.uuid" @click.prevent="handleNavClick(child)" :class="['app-vertical-navigation__submenu-item-title', { 'is--active': child.isActive}]" v-html="highlightMatch(child.name)"></a>
                      <div class="app-vertical-navigation__submenu-item-actions">
                        <span v-if="child.reviewed" class="element-featured-icon is--success is--xs">
                          <svg class="element-icon--check-circle element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-check-circle"></use></svg>
                        </span>
                        <span v-if="child.virtualFlagged" 
                          class="element-featured-icon is--warning is--xs"
                          :title="child.flagStateLabel">
                          <svg class="element-icon--eye-closed element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-eye-closed"></use></svg>
                        </span>
                        <span v-else-if="child.flagged" 
                          class="element-featured-icon is--warning is--xs"
                          :title="child.flagStateLabel">
                          <svg class="element-icon--eye-closed element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-eye-closed"></use></svg>
                        </span>
                        <span v-else-if="child.partialFlagged" 
                          class="app-project-sources-golden-source-navbar-partial-flag"
                          :title="child.flagStateLabel">
                          <span class="element-featured-icon is--warning is--xs">
                            <svg class="element-icon--eye-closed element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-eye-closed"></use></svg>
                          </span>
                          <span class="element-featured-icon is--xs">
                            <svg class="element-icon--eye-closed element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-eye-closed"></use></svg>
                          </span>
                        </span>
                        <span v-if="child.unsaved" class="element-badge badge-warning">Unsaved</span>
                      </div>
                  </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import DOMPurify from 'dompurify'
import { escapeRegExp } from 'lodash'

export default {
    name: 'ProjectSourcesNavBar',
    props: {
        project: {
            type: Object,
            required: true
        },
        topics: {
            type: Object,
            default: () => ({})
        },
        projectSource: {
            type: Object
        },
        topic: {
            type: Object,
            default: null
        },
        unsavedTopic: {
            type: String
        }
    },
    data() {
        return {
            input: '',
            query:  '',
            matches: [],
            searchQuery: '',
            parents: [],
            location:'',
            filteredTopics: [],
            totalReviewableTopics: 0,
            totalTopicReviewed: 0,
            projectReviewCompletion: 0
        }
    },
    async beforeMount() {
        this.location = `/project-sources/${this.projectSource.id}/review/`
        const params = new URLSearchParams(window.location.search)
        const search = params.get('search')
        if (search) {
            const sanitized = this.sanitizeQuery(search)
            this.searchQuery = sanitized
            this.input = sanitized
            await this.search()
        } else {
            this.filteredTopics = this.topics
            this.parentsTree()
            this.expandTree()
        }
    },
    methods: {
        async search (searchedTerm) {
          if(!this.searchQuery) {
            console.log('Search initiated with existing searchQuery:', this.searchQuery)
            this.searchQuery = this.input.trim()
          }
          try {
            // change url to standard and pass params only one search term period so replace
            const response  = await axios.get(`/project-sources/${this.projectSource.id}/search`, { params: { query: this.searchQuery }})
            const results = _.get(response, 'data.data', [])
            const uuidsToMatch = results.topics?.map(topic => topic.uuid) || []
            this.filteredTopics = this.topics
              .map(parent => {
                const matchingChildren = (parent.topics || []).filter(child => uuidsToMatch.includes(child.uuid))
                if (matchingChildren.length) {

                  return {
                    ...parent,
                    topics: matchingChildren
                  }
                }
                return null
              })
              .filter(Boolean)
            this.parentsTree()
            this.expandTree()
            const url = new URL(window.location)
            url.searchParams.set('search', this.searchQuery)
            window.history.pushState({}, '', url)
            console.log('Search response:', results)
          } catch (error) {
            console.error('Search error:', error)
          }
        },
        onSearch () {
          console.log('Search initiated with input:', this.input, this.searchQuery)
        },
        toggleExpanded (parent) {
          parent.expanded = !parent.expanded
        },
        parentsTree () {
          this.parents = []
          if (!Array.isArray(this.filteredTopics)) return
          this.filteredTopics.forEach(topic => {
            // Clone parent
            const parent = {
              ...topic,
              expanded: false,
              isActive: false,
              topics: (topic.topics || []).map(child => {
                  const flaggedCount = Number(child.flagged_count)
                  const chunkCount = Number(child.chunk_count)
                  
                  const manualFlagged = child.flagged
                  const virtualFlagged = chunkCount > 0 && flaggedCount === chunkCount
                  const partialFlagged = flaggedCount > 0 && flaggedCount < chunkCount
                  let flagStateLabel = ''

                  if (virtualFlagged) flagStateLabel = 'All references are excluded'
                  else if (manualFlagged) flagStateLabel = 'Topic excluded'
                  else if (partialFlagged) flagStateLabel = 'At least one reference, but not all, are excluded'

                  return {
                    ...child,
                    unsaved: child.uuid === this.unsavedTopic ? true : false,
                    isActive: false,
                    reviewed: child.reviewed || false,
                    flagged: child.flagged || false,
                    partialFlagged,
                    virtualFlagged,
                    flagStateLabel
                  }
              })
            }
            this.parents.push(parent);
          });
          let totalTopicsReviewable = 0
          let totalTopicReviewed = 0
          this.parents.forEach(parent => {
            totalTopicsReviewable += parent.topics ? parent.topics.length : 0
            totalTopicReviewed += parent.topics ? parent.topics.filter(child => child.reviewed).length : 0
          })
          this.projectReviewCompletion = totalTopicsReviewable > 0 ? Math.round((totalTopicReviewed / totalTopicsReviewable) * 100) : 0
          if (this.$refs.progressBarFill) {
            this.$refs.progressBarFill.style.width = `${this.projectReviewCompletion}%`
          }
        },
        expandTree () {
          const uuidMatch = this.topic?.uuid
            this.parents.forEach(parent => {
              parent.topics.forEach(child => {
                child.isActive = child.uuid === uuidMatch
                parent.expanded = child.isActive || parent.expanded
              });
            });
        },
        handleNavClick(clickedChild) {
          // Find any unsaved topic
          const unsaved = this.parents.flatMap(p => p.topics).find(c => c.unsaved)
          if (unsaved && unsaved.uuid !== clickedChild.uuid) {
            if (window.confirm('You have unsaved changes. Are you sure you want to leave?')) {
              window.location.href = this.location + clickedChild.uuid + (this.searchQuery ? `?search=${this.searchQuery}` : '')
            }
            // else do nothing
          } else {
            window.location.href = this.location + clickedChild.uuid + (this.searchQuery ? `?search=${this.searchQuery}` : '')
          }
        },
        sanitizeQuery (value) {
          if (typeof value !== 'string') return ''
          return DOMPurify.sanitize(value, { 
            ALLOWED_TAGS: [],
            ALLOWED_ATTR: [],
            RETURN_TRUSTED_TYPE: false 
          }).trim().slice(0, 200)
        },
        highlightMatch (text) {
          if (!this.searchQuery || !text) return text
          if (typeof text !== 'string') return text
          const escaped = escapeRegExp(this.searchQuery)
          const regex = new RegExp(`(${escaped})`, 'gi')
          return text.replace(regex, '<span class="search-highlight">$1</span>')
        },
        deleteTag () {
          this.searchQuery = ''
          this.filteredTopics = this.topics
          this.parentsTree()
          this.expandTree()
          const url = new URL(window.location)
          url.searchParams.delete('search')
          window.history.replaceState({}, '', url)
        }
    },
    computed: {
    },
    watch: {
      topics: {
        handler() {
          console.log('Topics updated:', this.topics)
          this.filteredTopics = this.topics
          this.parentsTree()
          this.expandTree()
        },
        deep: true,
      },
      unsavedTopic: {
        handler() {
          this.parentsTree()
          this.expandTree()
        },
        deep: true,
      }
    }
}
</script>
